import request from '../config/axiosConfig';
import { CREATE_UPDATE_NOTIFICATION, DELETE_NOTIFICATION, GET_LIST_NOTIFICATIONS, GET_NOTIFICATION_DETAIL } from '../constants/apiEndPoint';

export const getListNotificationsRequest = async (data) => {
  const result = await request({
    url: GET_LIST_NOTIFICATIONS,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getNotificationInfoRequest = async (data) => {
  const result = await request({
    url: GET_NOTIFICATION_DETAIL,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const createUpdateNotificationRequest = async (data) => {
  const result = await request({
    url: CREATE_UPDATE_NOTIFICATION,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deleteNotificationRequest = async (data) => {
  const result = await request({
    url: DELETE_NOTIFICATION,
    method: 'POST',
    data,
  });
  return result?.data;
};
